import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./style/dialog.scss?vue&type=style&index=0&id=9bf3e58a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.31_vue@3.5.31_typescript@5.6.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bf3e58a"]])

export default __exports__